<template>
  <div id="modal-history-ges">
    <b-table
      :items="itemsHistoryGes"
      :fields="fieldsHistoryGes"
      :busy="loadinghis"
      class="col-12 mt-5 table-views p-0"
    >
      <template #cell(Detalles)="row" @click="row.toggleDetails">
        <template @click="row.toggleDetails">
          <a
            v-if="row.item.details[0]"
            size="sm"
            @click="row.toggleDetails"
            class="mr-2"
            style="cursor: pointer; color: #5d5fef; vertical-align: middle"
          >
            <img
              v-if="row.detailsShowing"
              class="centerImg1"
              src="@/assets/images/icons/arrow-drop-up-line.svg"
              width="20px"
            />

            <img
              v-else
              class="centerImg1 resaltar"
              src="@/assets/images/icons/eye-line.svg"
              width="20px"
            />

            {{ row.detailsShowing ? "Ocultar" : "Ver" }}
            Detalles
          </a>

          <p v-else>---</p>
        </template>
      </template>
      <template #table-busy>
        <div class="text-center my-2 mb-3">
          <OverlayButton clase="overlay-md"></OverlayButton>
        </div>
      </template>
      <template #row-details="row">
        <b-table :items="row.item.details" style="background-color: #f3f3f3" />
      </template>
    </b-table>
    <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
      <Pagination :data="gesHistory"></Pagination>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import Pagination from "laravel-vue-pagination";
export default {
  components: {
    OverlayButton,
    Pagination,
  },
  data() {
    return {
      itemsHistoryGes: [],
      fieldsHistoryGes: ["Id", "Tipo", "Fecha", "Detalles"],
    };
  },
  computed: {
    ...mapState("modSVE", ["gesHistory", "loadinghis", "ges"]),
  },
  methods: {
    ...mapActions("modSVE", ["actGetHistoryGES"]),
    getHistoryGes(page = 1) {
      const me = this;
      me.itemsHistoryGes = [];
      let id = me.ges?.id;
      me.actGetHistoryGES({ id, page }).then(() => {
        me.gesHistory?.data?.forEach((x) => {
          me.itemsHistoryGes.push({
            Id: x.id,
            Tipo: x.modification_type,
            Fecha: x.date,
            details: x.history,
          });
        });
      });
    },
  },
  mounted() {
    const me = this;
    me.getHistoryGes(1);
  },
};
</script>

<style lang="scss" scoped></style>
